import axios from "../axios"
import apiUrls from "../urls"
// import { jsonp } from 'vue-jsonp'

export default {
    fetchLogin (data) {
        return axios.post(apiUrls.login, data)
    },
    // thirdPartyLogin(data) {
    //     console.log(data);
    //     return axios.post(apiUrls.passport, data)
    // },
    logout(data) {
        return axios.post(apiUrls.logout, data)
    },

}
